import React from "react";
import PropTypes from "prop-types";
import { Button, Modal, Menu } from "antd";
import ListView from "components/common/ListView";
import MaterialIcon from "components/common/MaterialIcon";
import { connect } from "react-redux";
import TimeTextField from "../TimeTextField";
import store from "store";
import { patchUser } from "../../Module";

import {
  indexUserFinancials,
  emptyUserFinancials,
  destroyUserFinancial,
} from "../../Module";

@authorize
@connect(
  (state) => ({
    financialInfos: state.Basic.Personnel.financialInfos,
  }),
  {
    index: indexUserFinancials,
    empty: emptyUserFinancials,
    destroy: destroyUserFinancial,
  }
)
@autobind
/**
 *
 */
export default class Setting extends React.PureComponent {
  static propTypes = {
    banks: PropTypes.arrayOf(PropTypes.object),
    user: PropTypes.object,
    can: PropTypes.func,
    onAdd: PropTypes.func,
    onEdit: PropTypes.func,
    index: PropTypes.func,
    empty: PropTypes.func,
    destroy: PropTypes.func,
    financialInfos: PropTypes.array,
  };

  /**
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
    };
  }

  /**
   *
   */
  componentDidMount() {
    const { user, index } = this.props;
    console.log("user,", user);
    index(user.id, (err) => !err && this.setState({ loading: false }));
  }

  /**
   *
   * @param {Object} item
   * @return {XML}
   * @private
   */
  _menu(item) {
    const { can, onEdit } = this.props;

    return (
      <Menu
        onClick={({ key }) => {
          switch (key) {
            case "edit":
              onEdit(item);
              break;
            case "delete":
            default:
              this._onDelete(item);
          }
        }}
      >
        <Menu.Item key="edit" disabled={!can("FinancialInfo@update")}>
          <MaterialIcon name="pencil" />
          {app.translate("main.Edit")}
        </Menu.Item>
        <Menu.Item key="delete" disabled={!can("FinancialInfo@destroy")}>
          <MaterialIcon name="delete" />
          {app.translate("main.Delete")}
        </Menu.Item>
      </Menu>
    );
  }

  /**
   *
   * @param {Object} item
   * @private
   */
  _onDelete(item) {
    const { destroy } = this.props;

    Modal.confirm({
      title: app.translate("routes.home.basic.personnel.Removing financial"),
      content: app.translate(
        "routes.home.basic.personnel.Are you sure removing financial with number",
        { number: item.accountNumber || item.cardNumber }
      ),
      onOk: () => destroy(item.id),
    });
  }
  updateData(newValue) {
    const { user } = this.props;
    console.log("newValue", newValue);
    console.log("user", user);
    this.setState({
      ceiling_overtime: newValue,
    });
  }
  _submit() {
    const { user } = this.props;
    console.log("user.profile", user.profile.ceilingOvertime);
    store.dispatch(
      patchUser(user.id, {
        profile: { ceiling_overtime: this.state.ceiling_overtime },
      })
    );
  }
  /**
   *
   * @return {XML}
   */
  render() {
    const { loading } = this.state;
    const { onAdd, financialInfos, onEdit, banks, user } = this.props;
    console.log("user?.profile?.ceilingOvertime",user?.profile?.ceilingOvertime);
    return (
      <div>
        <div style={{ width: "max-content", padding: "0 0 0 10px" }}>
          {app.translate("سقف اضافه‌کار ماهیانه ")}
        </div>

        <TimeTextField
          //  value={_data.monthRemainings[i] || '00:00'}
          defaultValue={
            user?.profile?.ceilingOvertime
              ? user?.profile?.ceilingOvertime
              : "00:00"
          }
          onChange={(newValue, index) => {
            // let changedData = { ..._data };
            // if (
            //   changedData.monthRemainings &&
            //   changedData.monthRemainings.length === 0
            // ) {
            //   changedData.monthRemainings = {};
            // }
            // changedData.monthRemainings[index] = newValue;
            this.updateData(newValue);
          }}

          // disabled={locked}
        />
        <Button
          type="primary"
          onClick={this._submit}
          style={{ marginTop: "8px" }}
        >
          {app.translate("main.Submit")}
        </Button>
      </div>
    );
  }
}
